/* spec: specs/product-card-redesign.md (FR-03 — toggle tap/teclado de los
   tooltips de pills "Compresión"/"Silueta" en la card layout 08).
   fix: specs/fixes/card-tooltips-mobile-tap.md — movido desde assets/custom.js,
   que solo se carga si settings.use_custom_js está activo (y está en false):
   el tap en mobile quedaba muerto. Este asset se carga siempre desde
   snippets/global-script-2.liquid.
   Vanilla, sin jQuery. El hover en desktop lo maneja CSS (@media hover:hover);
   este script cubre AC-12 (tap abre, tap fuera cierra, uno a la vez) y
   AC-14 (Enter via click nativo del button, Escape cierra y devuelve foco). */
(function () {
    'use strict';

    if (!('customElements' in window) || customElements.get('card-tooltips')) {
        return;
    }

    var closeTooltipItem = function (tooltipItem) {
        tooltipItem.classList.remove('is-open');
        var pillButton = tooltipItem.querySelector('.card-tooltips__pill');
        if (pillButton) {
            pillButton.setAttribute('aria-expanded', 'false');
        }
    };

    var closeAllTooltips = function (exceptItem) {
        document.querySelectorAll('.card-tooltips__item.is-open').forEach(function (openItem) {
            if (openItem !== exceptItem) {
                closeTooltipItem(openItem);
            }
        });
    };

    class CardTooltips extends HTMLElement {
        constructor() {
            super();

            this.addEventListener('click', (event) => {
                var pillButton = event.target.closest('.card-tooltips__pill');
                if (!pillButton) {
                    return;
                }
                event.stopPropagation();
                var tooltipItem = pillButton.closest('.card-tooltips__item');
                var wasOpen = tooltipItem.classList.contains('is-open');
                closeAllTooltips(tooltipItem);
                if (wasOpen) {
                    closeTooltipItem(tooltipItem);
                } else {
                    tooltipItem.classList.add('is-open');
                    pillButton.setAttribute('aria-expanded', 'true');
                }
            });

            this.addEventListener('keydown', (event) => {
                if (event.key !== 'Escape') {
                    return;
                }
                var openItem = this.querySelector('.card-tooltips__item.is-open');
                if (openItem) {
                    var pillButton = openItem.querySelector('.card-tooltips__pill');
                    closeTooltipItem(openItem);
                    if (pillButton) {
                        pillButton.focus();
                    }
                }
            });
        }
    }

    customElements.define('card-tooltips', CardTooltips);

    document.addEventListener('click', function (event) {
        if (event.target.closest('card-tooltips')) {
            return;
        }
        closeAllTooltips(null);
    });
})();
